<div>
  <span class="go-calendar__header">
    <div class="go-calendar__header--outside">
      <go-icon-button
        class="go-calendar__icon"
        [buttonDisabled]="previousYearDisabled"
        buttonIcon="keyboard_arrow_left"
        (handleClick)="previousYear()"
      ></go-icon-button>
    </div>
    <div class="go-calendar__header--center">
      {{year.translated}}
    </div>
    <div class="go-calendar__header--outside">
      <go-icon-button
        class="go-calendar__icon"
        [buttonDisabled]="nextYearDisabled"
        buttonIcon="keyboard_arrow_right"
        (handleClick)="nextYear()"
      ></go-icon-button>
    </div>
  </span>
  <div class="go-calendar__body">
    <table class="go-calendar__table">
      <tr *ngFor="let row of months" class="go-calendar__row">
        <td *ngFor="let col of row" class="go-calendar__date go-calendar__date--tall">
          <button
            class="go-calendar__cell"
            [disabled]="col.disabled"
            [ngClass]="{'go-calendar__cell--selected': col.selected, 'go-calendar__cell--focused': col.focused}"
            (click)="pickMonth(col.value)"
          >
            {{col.translated}}
          </button>
        </td>
      </tr>
    </table>
  </div>
</div>
